module.exports = __webpack_public_path__ + "img/head.2019a3af.png";